import { handleAspects } from './handleAspects.js';
export const applyAspects = (aspects) => (ev) => {
    const element = ev.target?.closest('[data-aspects]');
    try {
        const aspectsAttributes = JSON.parse(element?.dataset?.aspects ?? '[]');
        handleAspects({ aspectsAttributes, aspects, ev });
    }
    catch (_) {
        // Do nothing
    }
    // legal aspect, use always
    aspects.forwardQuery?.(ev);
};
//# sourceMappingURL=applyAspects.js.map